module.exports = __webpack_public_path__ + "images/img-3Qjvvm-.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/ranks/0.jpg
// module id = 2027
// module chunks = 0